module.exports = __webpack_public_path__ + "static/media/20ECE14.716cdd6c.jpg";